import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { ShieldCheck, ShieldAlert, ShieldX } from 'lucide-react';
import { cn } from '@/lib/utils';

function getScoreInfo(score) {
  if (score >= 80) {
    return {
      label: 'Compliant',
      color: 'text-vrs-green',
      bgColor: 'bg-vrs-green/10',
      borderColor: 'border-vrs-green/30',
      progressColor: '[&>div]:bg-vrs-green',
      icon: ShieldCheck,
    };
  }
  if (score >= 50) {
    return {
      label: 'At Risk',
      color: 'text-vrs-amber',
      bgColor: 'bg-vrs-amber/10',
      borderColor: 'border-vrs-amber/30',
      progressColor: '[&>div]:bg-vrs-amber',
      icon: ShieldAlert,
    };
  }
  return {
    label: 'Non-compliant',
    color: 'text-vrs-red',
    bgColor: 'bg-vrs-red/10',
    borderColor: 'border-vrs-red/30',
    progressColor: '[&>div]:bg-vrs-red',
    icon: ShieldX,
  };
}

export function ComplianceScore({ score = 0, lastUpdated }) {
  const info = getScoreInfo(score);
  const Icon = info.icon;

  return (
    <div
      data-testid="compliance-score"
      aria-label={`Compliance score ${score}, ${info.label}`}
      className="space-y-3"
    >
      <div className="flex items-center gap-3">
        <div className={cn('flex h-10 w-10 items-center justify-center rounded-lg border', info.bgColor, info.borderColor)}>
          <Icon className={cn('h-5 w-5', info.color)} />
        </div>
        <div>
          <div className="flex items-baseline gap-2">
            <span
              data-testid="compliance-score-badge"
              className={cn('text-3xl font-semibold font-mono tabular-nums tracking-tight', info.color)}
            >
              {score}
            </span>
            <span className="text-sm text-muted-foreground">/100</span>
          </div>
          <Badge
            variant="outline"
            className={cn('text-[10px] mt-0.5', info.color, info.borderColor)}
          >
            {info.label}
          </Badge>
        </div>
      </div>

      <Progress
        data-testid="compliance-score-progress"
        value={score}
        className={cn('h-2', info.progressColor)}
      />

      {lastUpdated && (
        <p className="text-[10px] text-muted-foreground">
          Last verified: {lastUpdated}
        </p>
      )}
    </div>
  );
}
